import React, { useState, useEffect } from 'react';
import './Milestones.css';
import DynamicBanner from '../include/DynamicBanner';
import api from '../../../../api';

function Milestones() {
  const [bannerData, setBannerData] = useState(null);
  const [timelineData, setTimelineData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedYearData, setSelectedYearData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/api/sitepages/about-milestones');
        const data = response.data;

        if (data.banner_data) setBannerData(data.banner_data);
        if (data.timeline_data) setTimelineData(data.timeline_data);
      } catch (error) {
        console.error('Error fetching milestone data:', error);
      }
    };

    fetchData();
  }, []);

  const handleOpenModal = (yearData) => {
    setSelectedYearData(yearData);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedYearData(null);
  };

  const handleModalContentClick = (e) => e.stopPropagation();

  if (!timelineData) return <></>;

  return (
    <>
      {bannerData && (
        <DynamicBanner
          images={bannerData.images}
          buttons={bannerData.buttons}
          heading={bannerData.heading}
        />
      )}

      <section className="timeline-section">
        <div className="sec-title text-center">
          <h2>{timelineData.heading}</h2>
        </div>

        <div className="container py-0 py-md-3">
          <div className="timeline-vertical">

            {timelineData.items.map((item, index) => (
              <div key={index} className={`timeline-item ${item.alignment}`}>
                
                <div className={`circle ${item.colorClass}`}>
                  <div className="circle-dot">{item.year}</div>
                </div>

                <div
                  className={
                    item.colorClass === 'light-blue'
                      ? 'content-box-light'
                      : 'content-box-dark'
                  }
                >
                  {/* ALL milestones displayed directly */}
                  <ul className="milestone-list">
                    {item.milestones.map((milestone, i) => (
                      <li key={i}>
                        <i className="fa fa-dot-circle-o"></i>
                        <span>{milestone}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Show View More only if viewmore has items */}
                  {item.viewmore && item.viewmore.length > 0 && (
                    <button
                      className="view-more-milestone"
                      onClick={() => handleOpenModal(item)}
                    >
                      View More
                    </button>
                  )}
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* MODAL */}
      <div
        id="timelineModal"
        className={`timeline-modal ${isModalOpen ? 'active' : ''}`}
        onClick={handleCloseModal}
      >
        <div className="modal-content-timeline" onClick={handleModalContentClick}>
          
          <div className="modal-header-timeline">
            <h3 className="modal-year">{selectedYearData?.year}</h3>
            <button className="modal-close" onClick={handleCloseModal}>×</button>
          </div>

         <ul className="modal-milestone-list">
  {[
    ...(selectedYearData?.milestones || []),
    ...(selectedYearData?.viewmore || [])
  ].map((milestone, i) => (
    <li key={i}>
      <i className="fa fa-dot-circle-o"></i>
      <span>{milestone}</span>
    </li>
  ))}
</ul>


        </div>
      </div>
    </>
  );
}

export default Milestones;
